<template>
  <div class="info">
    <div class="top_center">
      <div class="conten_box">
        <!-- <div class="tbinfo"> -->
        <div class="con_title">个人信息</div>
        <div class="con_title_top mb30">
          <div class="details radius">
            <div class="con_top center">我的头像</div>
            <!-- <div class="con_viv center">从相册中选择你喜欢的图片，点击上传</div> -->
            <div class="com_imh">
              <img v-if="form.headImgUrl" :src="form.headImgUrl" alt />
              <img v-else src="@/assets/img/info/tx.png" alt />
            </div>
            <div class="con_edit center cursor" @click="editHeadImg">
              修改头像
            </div>
          </div>
          <div class="w70 com_top com_tops mb50">
            <div class="com_form" style="width: 59%">
              <div>
                <el-form
                  ref="form"
                  :model="form"
                  label-position="right"
                  label-width="120px"
                >
                  <div class>
                    <el-form-item label="邮箱：">
                      <el-input
                        class="address_input"
                        style="width: 400px"
                        disabled
                        v-model="form.account"
                        placeholder="请输入邮箱："
                      ></el-input>
                      <span
                        v-if="form.emailVerify === '0'"
                        class="emailver coff ba6e center cursor"
                        @click="openEmailVer"
                        >验证</span
                      >
                    </el-form-item>
                  </div>
                  <div class>
                    <el-form-item label="手机号：">
                      <el-input
                        class="address_input"
                        style="width: 400px"
                        disabled
                        v-model="form.phone"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div style="width: 500px" class>
                    <el-form-item label="用户名：">
                      <el-input
                        class="address_input"
                        style="width: 400px"
                        maxlength="20"
                        v-model="form.name"
                        placeholder="请输入用户名"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div style="width: 500px" class>
                    <el-form-item label="公司名称：">
                      <el-input
                        class="address_input"
                        style="width: 400px"
                        maxlength="20"
                        v-model="form.companyName"
                        placeholder="请输入公司名称"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div style="width: 500px" class>
                    <el-form-item label style="padding-right: 100px">
                      <div>
                        <span
                          class="form_butt coff ba6e center cursor"
                          @click="submit"
                          >保存修改</span
                        >
                      </div>
                    </el-form-item>
                  </div>
                  <div></div>
                </el-form>
              </div>
            </div>
          </div>
        </div>
        <div class="sz18 font_bo">
          <p>立即前往[洞察情报]，开启联盟分销。</p>
          <p>
            如需指引，可点击查看
            <span class="co5a cursor" @click="goguide"
              >《FOSHO AFF 操作演示文档》</span
            >
          </p>
        </div>
        <div v-if="endDatestuts || mealType == 'FREE_DAY'">
          <div v-if="industrys.length || concats">
            <div class="con_title mt50">已选行业</div>
            <div class="w100 flex mb50 wrap already">
              <div
                class="industli center ru5 mt10 flex alcen"
                v-for="(item, index3) in industrys"
                :key="index3"
              >
                <el-tooltip class="item" effect="dark" placement="top">
                  <div slot="content">
                    {{ item.permitName }}
                    <p v-show="item.canModify === false">
                      <br />
                      {{ item.calculateTime }} 后可重置
                    </p>
                  </div>
                  <p>{{ item.permitName }}</p>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div v-if="endDatestuts || mealType == 'FREE_DAY'">
          <div v-if="brands.length || concats">
            <div class="con_title mt50">已选品牌</div>
            <div
              class="w100 flex mb50 wrap already"
              v-infinite-scroll="brandsLIstmapScroll"
              infinite-scroll-distance="50"
              infinite-scroll-delay="200"
              infinite-scroll-disabled="infiniteScrollFlag"
            >
              <div
                class="industli2 center ru5 mt10 flex alcen"
                v-for="(item, index3) in brands"
                :key="item.brandCode"
              >
                <img :src="item.brandLogo" alt />

                <el-tooltip class="item" effect="dark" placement="top">
                  <div slot="content">
                    {{ item.permitName }}
                    <p v-show="item.canModify === false">
                      <br />
                      {{ item.calculateTime }} 后可重置
                    </p>
                  </div>
                  <p>{{ item.permitName }}</p>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>

        <div v-if="endDatestuts && mealType != 'FREE_DAY'">
          <div
            style="display: block"
            class="con_title_top mt20"
            v-if="editstuts"
          >
            <div class="select_hp flex mb30">
              <div class="left flex select_hp_top baff">
                <div class="w40">
                  <!-- <div class="font_bo sz18 mb5">选择行业</div> -->
                  <div class="let_list ru5">
                    <div class="ttlt font_bo sz16 mb5">选中您需要的行业</div>
                    <div style="font-size: 12px" class="co70 mb10 ttlt">
                      您{{
                        restIndustryNum < 0
                          ? '需要减少' + Math.abs(restIndustryNum)
                          : '还可以添加' + restIndustryNum
                      }}个行业
                    </div>
                    <div class="list flex">
                      <button
                        class="sz14 cursor"
                        :disabled="hydisabled"
                        v-for="(item, index) in industryList"
                        :key="index"
                        @click="clindust(item, index)"
                      >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="item.bigIndustryName"
                          placement="top"
                        >
                          <p
                            class="ckcr ru5 sz14"
                            :class="item.isconts ? 'ckco' : ''"
                          >
                            {{ item.bigIndustryName }}
                          </p>
                        </el-tooltip>
                      </button>
                      <button class="empty"></button>
                      <button class="empty"></button>
                      <button class="empty"></button>
                      <button class="empty"></button>
                      <button class="empty"></button>
                    </div>
                  </div>
                </div>
                <div class="rchoose pdle">
                  <div class="ttlt font_bo sz16 mb5 pdtop">选中行业</div>
                  <div style="font-size: 12px" class="co70 mb10 ttlt"></div>
                  <div class="rig_twos flex" v-if="industryListtwo.length">
                    <template v-for="(item, index) in industryListtwo">
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div slot="content">
                          {{ item.bigIndustryName }}
                          <p v-show="item.canModify === false">
                            <br />
                            {{ item.calculateTime }} 后可重置
                          </p>
                        </div>
                        <button class="Selected flex ru5" :key="index">
                          <p class="p1">{{ item.bigIndustryName }}</p>
                          <p
                            class="p2 flex ru50"
                            v-show="item.canModify !== false"
                          >
                            <i
                              class="el-icon-close sz12 cursor"
                              @click="delindus(item, index)"
                            ></i>
                          </p>
                        </button>
                      </el-tooltip>
                    </template>
                    <button class="Selected2"></button>
                    <button class="Selected2"></button>
                    <button class="Selected2"></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="select_hp baff mb30">
              <div class="ttlt font_bo sz16 mb5 pad15 flex pt10">
                <div style="width: 40%">选中您需要的品牌</div>
                <div class="pdle" style="width: 60%">选中品牌</div>
              </div>
              <div style="font-size: 12px" class="co70 mb10 ttlt pad15 padt0">
                您{{
                  restBrandNum < 0
                    ? '需要减少' + Math.abs(restBrandNum)
                    : '还可以添加' + restBrandNum
                }}个品牌
              </div>
              <div class="left flex select_hp_top_two">
                <div class="nright">
                  <div class="let_list ru5">
                    <div class="font_bo sz16 mb5 pad15">
                      PART A: 您可以筛选行业，从标杆品牌中选择
                    </div>
                    <div class="list flex">
                      <button
                        class="sz14 cursor"
                        v-for="(item, index) in brandList"
                        :key="index"
                        @click="clbrand(item, index)"
                      >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="item.bigIndustryName"
                          placement="top"
                        >
                          <p
                            class="ckcr ru5 sz14"
                            :class="curts == index ? 'ckco' : ''"
                          >
                            {{ item.bigIndustryName }}
                          </p>
                        </el-tooltip>
                      </button>
                      <button class="empty"></button>
                      <button class="empty"></button>
                      <button class="empty"></button>
                      <button class="empty"></button>
                      <button class="empty"></button>
                    </div>
                  </div>
                </div>
                <div class="rchoose pd54">
                  <div class="rig_list flex">
                    <button
                      class="flex rig_lists cursor"
                      :disabled="ppdisabled"
                      v-for="(item, index) in brandListtwo"
                      :key="index"
                      @click="clbrandtwo(item, index)"
                    >
                      <div
                        class="flex h100 cursor choosetag"
                        :class="item.havePermit ? 'ckco' : ''"
                      >
                        <img
                          v-show="item.brandLogo"
                          :src="item.brandLogo"
                          alt
                        />
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="item.brandName"
                          placement="top"
                        >
                          <p class="p1">{{ item.brandName }}</p>
                        </el-tooltip>
                      </div>
                    </button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                  </div>
                </div>
              </div>
              <div class="part w100">
                <div class="font_bo sz16 mb5">
                  PART B: 您也可以搜索想要的品牌后添加
                </div>
                <div style="font-size: 12px" class="co70 mb10 ttlt">
                  *搜索结果括号中标注了该品牌已收录的数量区间
                </div>
                <div
                  ref="targetElement"
                  style="height: 40px"
                  class="mb10 el_sele"
                >
                  <el-input
                    v-model="value"
                    style="height: 100% !important"
                    clearable
                    prefix-icon="el-icon-search"
                    placeholder="搜索品牌"
                    @input="remoteMethod"
                    @focus="isDropdownVisible = true"
                  ></el-input>
                  <div
                    class="el_op ru5"
                    v-if="isDropdownVisible && value && opshend.length"
                  >
                    <div
                      class="el_op_list flex alcen"
                      v-for="(item, index) in opshend"
                      :key="index"
                      :class="item.havePermit ? 'ischoose' : ''"
                      @mouseenter="mouseover(item, index)"
                      @mouseleave="mouseout(item, index)"
                      @click="addbrands(item, index)"
                    >
                      <div class="el_op_list_brandName">
                        {{ item.brandName }}
                      </div>
                      <div class="el_op_list_website">{{ item.website }}</div>
                      <div v-if="item.countDesc">( {{ item.countDesc }} )</div>
                      <el-button
                        disabled
                        v-if="item.havePermit"
                        class="add1 center ru5"
                        >已添加</el-button
                      >
                    </div>
                  </div>
                  <div class="el_op2 flex baff jucen alcen co70 sz14 mt10">
                    如需其他品牌，欢迎点击页面右上角联系我们
                  </div>
                </div>
              </div>
              <div class="w100 savebtn">
                <div
                  class="rig_two flex baff mb30"
                  v-if="selectedList.length"
                  v-infinite-scroll="brandsLIstmapScroll"
                  infinite-scroll-distance="50"
                  infinite-scroll-delay="200"
                  infinite-scroll-disabled="infiniteScrollFlag"
                >
                  <template v-for="(item, index) in selectedList">
                    <el-tooltip class="item" effect="dark" placement="top">
                      <div slot="content">
                        {{ item.brandName }}
                        <p v-show="item.canModify === false">
                          <br />
                          {{ item.calculateTime }} 后可重置
                        </p>
                      </div>
                      <button class="Selected flex ru5" :key="index">
                        <img :src="item.brandLogo" alt />

                        <p class="p1">{{ item.brandName }}</p>
                        <p
                          class="p2 flex ru50"
                          v-show="item.canModify !== false"
                        >
                          <i
                            class="el-icon-close sz12 cursor"
                            @click="delbrands(item, index)"
                          ></i>
                        </p>
                      </button>
                    </el-tooltip>
                  </template>

                  <button class="empty"></button>
                  <button class="empty"></button>
                  <button class="empty"></button>
                  <button class="empty"></button>
                  <button class="empty"></button>
                  <button class="empty"></button>
                  <button class="empty"></button>
                  <button class="empty"></button>
                </div>
              </div>

              <div class="w100 savebtn">
                <div v-if="addIndustryList.length > 0">
                  <div class="part font_bo sz16 mb5">待新增行业</div>
                  <div class="rig_edit flex baff">
                    <button
                      class="Selected flex ru5"
                      v-for="(item, index) in addIndustryList"
                      :key="item.permitCode"
                    >
                      <img :src="item.brandLogo" alt />
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.bigIndustryName"
                        placement="top"
                      >
                        <p class="p1">{{ item.bigIndustryName }}</p>
                      </el-tooltip>
                      <!-- <p class="p2 flex ru50"><i class="el-icon-close sz12 cursor" @click="delbrands(item, index)"></i>
                      </p>-->
                    </button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                  </div>
                </div>

                <div v-if="deleteIndustryList.length > 0">
                  <div class="part font_bo sz16 mb5">待移除行业</div>
                  <div class="rig_edit flex baff mb30">
                    <button
                      class="Selected flex ru5"
                      v-for="(item, index) in deleteIndustryList"
                      :key="item.permitCode"
                    >
                      <img :src="item.brandLogo" alt />
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.bigIndustryName"
                        placement="top"
                      >
                        <p class="p1">{{ item.bigIndustryName }}</p>
                      </el-tooltip>
                      <!-- <p class="p2 flex ru50"><i class="el-icon-close sz12 cursor" @click="delbrands(item, index)"></i>
                      </p>-->
                    </button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                  </div>
                </div>
                <div v-if="addList.length > 0">
                  <div class="part font_bo sz16 mb5">待新增品牌</div>
                  <div class="rig_edit flex baff">
                    <button
                      class="Selected flex ru5"
                      v-for="(item, index) in addList"
                      :key="item.permitCode"
                    >
                      <img :src="item.brandLogo" alt />
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.brandName"
                        placement="top"
                      >
                        <p class="p1">{{ item.brandName }}</p>
                      </el-tooltip>
                      <!-- <p class="p2 flex ru50"><i class="el-icon-close sz12 cursor" @click="delbrands(item, index)"></i>
                      </p>-->
                    </button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                  </div>
                </div>

                <div v-if="deleteList.length > 0">
                  <div class="part font_bo sz16 mb5">待移除品牌</div>
                  <div class="rig_edit flex baff mb30">
                    <button
                      class="Selected flex ru5"
                      v-for="(item, index) in deleteList"
                      :key="item.permitCode"
                    >
                      <img :src="item.brandLogo" alt />
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.brandName"
                        placement="top"
                      >
                        <p class="p1">{{ item.brandName }}</p>
                      </el-tooltip>
                      <!-- <p class="p2 flex ru50"><i class="el-icon-close sz12 cursor" @click="delbrands(item, index)"></i>
                      </p>-->
                    </button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                    <button class="empty"></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="w100 center">
              <p class="submithp coff cursor ba6e ru5" @click="preserve">
                保存选择
              </p>
              <p>*确认选择行业/品牌后不可更改</p>
            </div>
          </div>
        </div>
        <div class="mt50" v-if="!endDatestuts">
          <span class="cursor" @click="purchase">立即购买</span>
        </div>
        <div class="con_title mt50 mb20">购买记录</div>
        <div class="flex renews_top" v-if="endDate">
          <p>套餐到期时间: {{ endDate }}</p>
        </div>
        <!-- <div class="flex" v-if="endDate || endDatestuts">
          <p v-if="mealType != 'FREE_DAY'" class="renews center coff ru5 mb20 sz14 cursor" @click="renew(1)">点击续费</p>
          <p class="renews center coff ru5 mb20 sz14 cursor" @click="renew(2)" v-if="strsstuts">套餐升级</p>
        </div>-->
        <div class="con_title_top">
          <div class="w100 com_top mb50 co70">
            <div class="mb50">
              <el-table
                border
                fit
                empty-text="暂无数据"
                :data="infolist"
                :header-cell-style="{ textAlign: 'center' }"
                :cell-style="{ textAlign: 'center' }"
                :row-style="{ height: '96px' }"
                style="width: 100%"
              >
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <P
                      class="P_Table"
                      v-for="(item, index) in props.row.mealTypeDesc"
                      :key="index"
                      >-{{ item }}</P
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="orderNo"
                  label="订单号"
                  width
                ></el-table-column>
                <el-table-column
                  prop="mealType"
                  label="类别"
                  min-width="160"
                ></el-table-column>
                <el-table-column
                  prop="paymentPrice"
                  label="价格￥"
                  min-width="160"
                ></el-table-column>
                <el-table-column
                  prop="paymentTime"
                  label="购买时间"
                  min-width="160"
                ></el-table-column>
                <!-- <el-table-column fixed="right" label="" width="200">
                  <template slot-scope="scope">
                    <p @click="deleteHandel(scope.row)"> <i class="el-icon-delete  cursor"></i></p>
                  </template>
                </el-table-column>-->
              </el-table>
            </div>
            <div v-if="!endDate">
              <div class="purchase w40">
                <div style="font-size: 16px" class="center w100 mb50">
                  点击立即购买，前往购买套餐。
                </div>
                <div class="center w100 mb50 buy flex">
                  <div class="flex co6e buy_en">
                    <div class="co6e cursor" @click="purchase">立即购买</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="选择头像"
      :visible.sync="dialogVisible"
      width="35%"
      :center="true"
      :modal="false"
      :show-close="false"
    >
      <div class="hedimg">
        <div
          class="hedimg_img cursor"
          v-for="(item, index) in headImgUrlList"
          :key="index"
          @click="submitimg(item, index)"
        >
          <img
            :src="item.url"
            alt
            :class="isactive == index ? 'addclass' : ''"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          style="background: #be3c6e; border: none; coloe: #fff"
          type="primary"
          :disabled="disabled"
          @click="oksubmit"
        >
          <span style="color: #fff">确 定</span>
        </el-button>
      </span>
    </el-dialog>
    <div class="nologins" v-if="dialogVisibletwo">
      <div class="nologins_title">
        <div class="nologins_title_icon">
          <i class="el-icon-close cursor" @click="dialogVisibletwo = false"></i>
        </div>
        <div class="nologins_title_img">
          <img src="../../assets/img/home/kf2.png" alt />
        </div>
        <div class="nologins_title_text center">咨询微信客服，购买套餐</div>
      </div>
    </div>
    <div class="nologins" v-if="dialogVisiblesher">
      <div class="nologins_title2">
        <div class="nologins_title_icon">
          <i class="el-icon-close cursor" @click="dialogVi"></i>
        </div>
        <div class="nologins_title_p">
          <p class="w100 center">您的套餐未到期，请选择续费或升级。</p>
        </div>
        <!-- <div class="nologins_title_text center">
          <span class="cursor sz12 coff ru5" @click="renew(1)">套餐续费</span> <span class="cursor sz12 coff ru5"
            @click="renew(2)">套餐升级</span>
        </div>-->
      </div>
    </div>

    <div class="expire" v-if="restDay < 6 && restDay">
      <div class="w100 h100 ba6e" v-if="guicon">
        <div class="expire_top w100 h100 flex coff jucen alcen">
          <span v-if="restDay < 6 && restDay > 0"
            >您的套餐还有{{ restDay }}天到期</span
          >
          <span v-else-if="restDay < 0 || !endDatestuts"
            >您还没有购买套餐或套餐已到期</span
          >
          <span v-else-if="restDay == 0">您的套餐将在今天到期</span>
          <p class="expire_icon cursor" @click="guicon = false">
            <i class="el-icon-close"></i>
          </p>
        </div>
      </div>
    </div>

    <el-dialog
      title
      :visible.sync="saveDialogVisible"
      width="30%"
      :show-close="false"
      :modal="false"
    >
      <div>
        <div class="addfo" v-if="!tipMessage3">
          <div class="font_bo sz16 mb30" v-show="tipIndustryMessage1">
            {{ tipIndustryMessage1 }}
          </div>
          <div class="font_bo sz16 mb30" v-show="tipIndustryMessage2">
            {{ tipIndustryMessage2 }}
          </div>
          <div class="font_bo sz16 mb30" v-show="tipMessage1">
            {{ tipMessage1 }}
          </div>
          <div class="font_bo sz16 mb30" v-show="tipMessage2">
            {{ tipMessage2 }}
          </div>
        </div>
        <div v-else class="addfo mb20">{{ tipMessage3 }}</div>
        <div class="name_butt flex">
          <div
            class="center ru5 ba6e coff cursor mr8"
            v-if="canSave"
            @click="handleSave"
          >
            保存
          </div>
          <div
            class="center ru5 baff butt2 cursor co00"
            @click="saveDialogVisible = false"
          >
            取消
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="邮箱验证" :visible.sync="emaildialogVisible" width="30%">
      <span>
        <div class="flex" style="align-items: center; gap: 10px">
          <div class="verification">
            <!-- <el-form-item label prop="code"> -->
            <el-input
              v-model="form.code"
              placeholder="验证码"
              oninput="value=value.replace(/[^\d]/g,'')"
              maxlength="6"
            ></el-input>
            <!-- </el-form-item> -->
          </div>
          <div class="wngji_yzm">
            <span
              class="emailver coff ba6e center cursor font_bo"
              @click="sendForget"
              v-if="isSendForget"
              >发送验证码</span
            >
            <span
              class="emailver coff ba6e center cursor font_bo"
              v-if="!isSendForget"
              >{{ sendmsgforgetcomlis }}</span
            >
          </div>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="emaildialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleVerifyEmail">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  QUERY,
  HEADIMGS,
  INFO,
  EXIT,
  HEADIMG,
  RECORDS,
  DEL,
  PERMITS,
  industryAll,
  brandAll,
  ADDPERMITS,
  UPDATESTR,
  CHECKBRANDATPERMIT,
  CHECKBRANDS
} from '../../api/personal'
import icp from '../../views/icp/icp'
import { CODEFORPASSWORD, EMAILVERIFY } from '../../api/login'
export default {
  components: {
    icp
  },
  data() {
    return {
      form: {
        // 用户信息
        name: '', // 用户名
        phone: '', // 手机号
        account: '', // 账号
        headImgUrl: '', // 头像
        id: '',
        companyName: '',
        code: ''
      },
      dialogVisible: false,
      disabled: true,
      dialogVisibletwo: false,
      headImgUrlList: [],
      nologin: true,
      isactive: -1,
      headImgUrl: '',
      id: '', // 用户id
      infolist: [],
      industryList: [], // 行业列表
      industryListtwo: [], // 已选行业列表
      industrys: [], // 行业套餐列表
      brandList: [], //品牌套餐列表
      brandListtwo: [], //行业下品牌套餐列表
      selectedList: [], // 已选行业列表
      restBrandNum: null,
      countdown: '', // 套餐倒计时
      brands: [], // 品牌
      brandCode: [],
      tablestuitsL: 1, // 购买记录
      validParam: localStorage.getItem('validParam'),
      endDate: '',
      endDatestuts: false, // 套餐到期状态
      restIndustryNum: null, //品牌
      // hydisabled: false,
      // ppdisabled: false,
      unm: null,
      curts: null,
      twonums: null,
      concats: '', // 倒计时
      day: '', // 天
      editstuts: true, // 行业品牌选择状态
      value: '',
      opshend: [],
      namecont: this.$route.query.namecont,
      dialogVisiblesher: false,
      restDay: '',
      guicon: true,
      mealType: '',
      strsstuts: true,

      // 品牌滚动参数
      brandsParams: {
        currentPage: 1,
        size: 60
      },
      infiniteScrollFlag: false,

      clickedIndustry: [], //点击过行业
      addList: [], //待新增
      deleteList: [], //待移除
      addIndustryList: [], // 待新增行业
      deleteIndustryList: [], // 待移除行业

      saveDialogVisible: false,
      tipIndustryMessage1: null,
      tipIndustryMessage2: null,
      tipMessage1: null,
      tipMessage2: null,
      tipMessage3: null,
      canSave: true,

      emaildialogVisible: false, //邮箱验证弹窗
      isSendForget: true, // 修改发送验证码
      sendmsgforgetcomlis: '发送验证码', // 修改密码
      isDropdownVisible: false
    }
  },
  mounted() {
    this.clickedIndustry = []
    this.industrymap()
    this.queryInfo()
    this.updateStr()
    if (this.$route.query.namecont) {
      this.dialogVisiblesher = true
    }
    document.addEventListener('click', this.handleClickOutside)
  },
  computed: {
    hydisabled() {
      if (this.restIndustryNum <= 0) {
        return true
      } else {
        return false
      }
    },
    ppdisabled() {
      if (this.restBrandNum <= 0) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    // 选择行业
    clindust(e, index) {
      this.industryList[index].isconts = true
      var result = this.industryListtwo.some(function (item) {
        if (item.bigIndustryCode === e.bigIndustryCode) {
          return true
        }
      })
      if (result) {
      } else {
        this.industryListtwo.push(e)
        this.industryListtwo = [...new Set(this.industryListtwo)]
        this.restIndustryNum--
        this.handleAddIndustryList(e)
      }
    },
    // 删除已选行业
    delindus(e, index) {
      this.industryListtwo[index].isconts = false
      this.restIndustryNum++
      this.industryListtwo.splice(index, 1)
      this.industryList.filter((item, index) => {
        if (item.isconts === e.isconts) {
          return (this.industryList[index].isconts = false)
        }
      })

      this.handleDeleteIndustryList(e)
    },
    // 选择品牌
    clbrand(e, index) {
      this.curts = index
      const flag = this.clickedIndustry.some(
        (item) => item.key == e.bigIndustryCode
      )
      if (!flag) {
        brandAll({ bigIndustryCode: e.bigIndustryCode }).then((res) => {
          this.clickedIndustry.push({
            key: e.bigIndustryCode,
            value: res.data.body
          })
          this.brandListtwo = res.data.body
        })
      } else {
        this.clickedIndustry.forEach((item2) => {
          if (item2.key == e.bigIndustryCode) {
            this.brandListtwo = item2.value
          }
        })
      }
    },
    //选择行业下品牌
    clbrandtwo(e, index) {
      this.brandListtwo[index].havePermit = true
      var obj = {
        brandCode: e.brandCode,
        brandLogo: e.brandLogo,
        brandName: e.brandName,
        canModify: e.canModify,
        calculateTime: e.calculateTime
      }
      var result = this.selectedList.some(function (item) {
        if (item.brandCode === e.brandCode) {
          return true
        }
      })
      if (result) {
      } else {
        this.selectedList.push(obj)
        var objs = {}
        this.selectedList = this.selectedList.reduce(function (item, next) {
          objs[next.brandCode]
            ? ''
            : (objs[next.brandCode] = true && item.push(next))
          return item
        }, [])
        this.selectedList = [...new Set(this.selectedList)]
        this.restBrandNum--
        this.handleAddList(obj)
      }
      // if (this.restBrandNum < 0) {
      //   this.restBrandNum = 0;
      // }
      // if (this.restBrandNum != 0) {
      //   this.ppdisabled = false;
      // } else {
      //   this.ppdisabled = true;
      // }
      if (this.opshend.length) {
        this.opshend.filter((item) => {
          if (item.brandCode == e.brandCode) {
            return (item.isconts = true)
          }
        })
      }
    },
    // 删除已选品牌 备份
    //  delbrands(e, index) {
    //   this.selectedList[index].isconts = false
    //   this.selectedList.splice(index, 1)
    //   this.brandListtwo.filter((item, index) => {
    //     if (item.brandCode === e.brandCode) {
    //       return this.brandListtwo[index].isconts = false
    //     }
    //   })
    //   if (this.selectedList.length < this.twonums) {
    //     this.ppdisabled = false
    //   }
    //   this.restBrandNum++
    //   if (this.restBrandNum != 0) {
    //     this.ppdisabled = false
    //   } else {
    //     this.ppdisabled = true
    //   }

    //   // 加入待删除列表
    //   this.handleDeleteList(e, index)

    // },
    // 删除已选品牌
    delbrands(e, index) {
      let index1
      this.selectedList.forEach((item, index) => {
        if (item.brandCode == e.brandCode) {
          index1 = index
          item.isconts = false
        }
      })
      this.selectedList[index1].isconts = false
      let objTemp = this.selectedList[index1]
      this.selectedList.splice(index1, 1)
      // this.brandListtwo.filter((item, index) => {
      //   if (item.brandCode === e.brandCode) {
      //     return this.brandListtwo[index].isconts = false
      //   }
      // })
      this.clickedIndustry.forEach((item) => {
        item.value.forEach((item2) => {
          if (item2.brandCode == e.brandCode) {
            item2.havePermit = false
          }
        })
      })

      // if (this.selectedList.length < this.twonums) {
      //   this.ppdisabled = false;
      // }
      this.restBrandNum++
      // if (this.restBrandNum != 0) {
      //   this.ppdisabled = false;
      // } else {
      //   this.ppdisabled = true;
      // }

      // 加入待删除列表
      this.handleDeleteList(objTemp)
    },
    // 添加待移除列表
    handleDeleteList(obj) {
      let flag3 = false
      let index3 = null
      this.addList.forEach((item, index2) => {
        if (item.brandCode === obj.brandCode) {
          index3 = index2
          flag3 = true
        }
      })
      if (flag3) {
        this.$nextTick(() => {
          this.addList.splice(index3, 1)
        })
      }

      let index1 = null
      let flag = false
      this.deleteList.forEach((item, index) => {
        if (item.brandCode === obj.brandCode) {
          index1 = index
          flag = true
        }
      })
      if (!flag) {
        this.deleteList.push(obj)
      }
    },
    // 添加待添加列表
    handleAddList(obj) {
      let flag3 = false
      let index3 = null
      this.deleteList.forEach((item, index2) => {
        if (item.brandCode === obj.brandCode) {
          index3 = index2
          flag3 = true
        }
      })
      if (flag3) {
        this.$nextTick(() => {
          this.deleteList.splice(index3, 1)
        })
      }

      let index1 = null
      let flag = false
      this.addList.forEach((item, index) => {
        if (item.brandCode === obj.brandCode) {
          index1 = index
          flag = true
        }
      })
      if (!flag) {
        this.addList.push(obj)
      }
    },
    // 添加待移除列表
    handleDeleteIndustryList(obj) {
      let flag3 = false
      let index3 = null
      this.addIndustryList.forEach((item, index2) => {
        if (item.bigIndustryCode === obj.bigIndustryCode) {
          index3 = index2
          flag3 = true
        }
      })
      if (flag3) {
        this.$nextTick(() => {
          this.addIndustryList.splice(index3, 1)
        })
      }

      let index1 = null
      let flag = false
      this.deleteIndustryList.forEach((item, index) => {
        if (item.bigIndustryCode === obj.bigIndustryCode) {
          index1 = index
          flag = true
        }
      })
      if (!flag) {
        this.deleteIndustryList.push(obj)
      }
    },
    handleAddIndustryList(obj) {
      let flag3 = false
      let index3 = null
      this.deleteIndustryList.forEach((item, index2) => {
        if (item.bigIndustryCode === obj.bigIndustryCode) {
          index3 = index2
          flag3 = true
        }
      })
      if (flag3) {
        this.$nextTick(() => {
          this.deleteIndustryList.splice(index3, 1)
        })
      }

      let index1 = null
      let flag = false
      this.addIndustryList.forEach((item, index) => {
        if (item.bigIndustryCode === obj.bigIndustryCode) {
          index1 = index
          flag = true
        }
      })
      if (!flag) {
        this.addIndustryList.push(obj)
      }
    },
    // 套餐可修改时间
    updateStr() {
      UPDATESTR().then((res) => {
        if (res.data.body) {
          this.concats = res.data.body
        }
      })
    },
    /**
     * queryInfo()
     * 获取登录信息
     */
    queryInfo() {
      QUERY().then((res) => {
        if (res.data.code == 'nolog') {
          this.nologin = false
        } else if (res.data.code == 'forceout') {
          // this.$message({
          //   message: '账号在其他地方登录,您被迫下线',
          //   type: 'warning'
          // });
          this.nologin = false
          localStorage.removeItem('token')
        } else {
          this.nologin = true
          this.form.name = res.data.body.name
          this.form.phone = res.data.body.phone
          this.form.account = res.data.body.account
          this.form.emailVerify = res.data.body.emailVerify
          this.form.id = res.data.body.id
          this.id = res.data.body.id
          this.form.headImgUrl = res.data.body.headImgUrl
          this.form.companyName = res.data.body.companyName
          this.name = res.data.body.name
          this.headImgUrl = res.data.body.headImgUrl
          this.headImgUrltop = res.data.body.headImgUrl
          localStorage.setItem('id', res.data.body.id)
          this.decords()
        }
      })
    },
    /**
     * editHeadImg()
     * 获取头像集合
     */
    editHeadImg() {
      HEADIMGS().then((res) => {
        this.headImgUrlList = res.data.body
        this.dialogVisible = true
      })
    },
    /**
     * submit()
     * 修改用户名 账号
     */
    submit() {
      let data = {
        id: this.form.id,
        name: this.form.name,
        companyName: this.form.companyName
      }
      if (!this.form.name) {
        this.$message.error('请输入用户名')
        return
      }
      if (!this.form.companyName) {
        this.$message.error('请输入公司名称')
        return
      }
      INFO(data).then((res) => {
        if (res.data.code == 'success') {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          if (res.data.code == 'error') {
            this.$message.error(res.data.msg)
          } else {
            this.$router.push({ path: './demo', query: { r: 6 } })
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 获取购买记录
    decords() {
      RECORDS({
        userId: this.id
      }).then((res) => {
        if (res.data.body) {
          this.infolist = res.data.body.datas
          this.restDay = Number(res.data.body.restDay)
          this.infolist.map((item) => {
            if (item.mealTypeDesc) {
              return (item.mealTypeDesc = item.mealTypeDesc.split('::'))
            }
          })
          var strs = res.data.body.mealType.substring(0, 2)
          if (strs == 'B_') {
            this.strsstuts = false
          } else {
            this.strsstuts = true
          }
        }
        if (res.data.body.endDate) {
          let date1_s = res.data.body.endDate.replace(/\-/g, '/')
          let date2_s = this.$moment()
            .format('YYYY-MM-DD HH:mm:ss')
            .replace(/\-/g, '/')
          let date1_unix = Date.parse(date1_s) //將字符串格式日期转化为时间戳，就是1970年到当前日期的毫秒数
          let date2_unix = Date.parse(date2_s) //將字符串格式日期转化为时间戳，就是1970年到当前日期的毫秒数
          if (date1_unix - date2_unix > 0) {
            this.endDatestuts = true // 未过期
          } else if (date1_unix - date2_unix < 0) {
            this.endDatestuts = false // 已经过期
          }
          this.endDate = res.data.body.endDate
        }
        this.mealType = res.data.body.mealType
        if (res.data.body) {
          this.tablestuitsL = 1
        } else {
          this.tablestuitsL = 2
        }
      })
    },
    industrymap() {
      industryAll().then((res) => {
        this.industryList = []
        this.brandList = []
        let arr = res.data.body
        arr.map((item) => {
          this.industryList.push(Object.assign({}, item, { isconts: false }))
          this.brandList.push(Object.assign({}, item, { isconts: false }))
        })
        this.permits()
      })
    },
    // 获取套餐
    permits() {
      this.brandsParams = {
        currentPage: 1,
        size: 60
      }
      PERMITS(this.brandsParams).then((res) => {
        if (res.data.body) {
          this.brands = res.data.body.brands
          this.industrys = res.data.body.industrys
          this.editstuts = res.data.body.canModify
          if (
            res.data.body.industrys.length > 0 ||
            (res.data.body.brands.length === 0 &&
              res.data.body.restIndustryNum === 0)
          ) {
            localStorage.setItem('haveIndustry', true)
          } else {
            localStorage.setItem('haveIndustry', false)
          }
          var arr = this.industrys.map((item) => {
            return item.permitCode
          })
          this.industryListtwo = []
          this.industryList
            .filter((item, index) => {
              if (arr.includes(item.bigIndustryCode)) {
                item.isconts = true
                return true
              } else {
                item.isconts = false
                return false
              }
            })
            .forEach((item) => {
              if (item.isconts) {
                const index = arr.indexOf(item.bigIndustryCode)
                if (index !== -1) {
                  this.industryListtwo.push({
                    ...item,
                    ...res.data.body.industrys[index]
                  })
                }
              }
            })

          var arr2 = this.brands.map((item) => {
            return {
              brandCode: item.permitCode,
              brandLogo: item.brandLogo,
              brandName: item.permitName,
              canModify: item.canModify,
              calculateTime: item.calculateTime
            }
          })
          this.selectedList = arr2
          this.restIndustryNum = res.data.body.restIndustryNum
          // if (this.restIndustryNum < 0) {
          //   this.restIndustryNum = 0;
          // }
          this.unm = res.data.body.restIndustryNum
          this.restBrandNum = res.data.body.restBrandNum
          // if (this.restBrandNum < 0) {
          //   this.restBrandNum = 0;
          // }
          // this.twonums = res.data.body.restBrandNum;
        }
      })
    },
    // 已选品牌滚动加载
    brandsLIstmapScroll() {
      // 滚动加载参数
      this.brandsParams.currentPage++
      this.infiniteScrollFlag = true
      PERMITS(this.brandsParams).then((res) => {
        if (res.data.body) {
          this.brands = this.brands.concat(res.data.body.brands)
          let tempBrands = []
          tempBrands = res.data.body.brands
          var tempArr = tempBrands.map((item) => {
            return {
              brandCode: item.permitCode,
              brandLogo: item.brandLogo,
              brandName: item.permitName
            }
          })
          this.selectedList = this.selectedList.concat(tempArr)
          this.infiniteScrollFlag = false
        }
      })
    },
    // 保存前
    preserve() {
      this.tipMessage1 = null
      this.tipMessage2 = null
      this.tipMessage3 = null
      this.tipIndustryMessage1 = null
      this.tipIndustryMessage2 = null
      let param = {}
      let addBrands = []
      let deleteBrands = []
      let addIndustries = []
      let deleteIndustries = []
      this.addList.forEach((item) => {
        addBrands.push(item.brandCode)
      })
      this.deleteList.forEach((item) => {
        deleteBrands.push(item.brandCode)
      })
      this.deleteIndustryList.forEach((item) => {
        deleteIndustries.push(item.bigIndustryCode)
      })
      this.addIndustryList.forEach((item) => {
        addIndustries.push(item.bigIndustryCode)
      })
      this.saveDialogVisible = true
      param.addBrands = addBrands
      param.deleteBrands = deleteBrands
      param.addIndustries = addIndustries
      param.deleteIndustries = deleteIndustries
      CHECKBRANDS(param).then((res) => {
        if (res.data.code == 'success') {
          let addtemp = ''
          let deletetemp = ''
          let addIndustrytemp = ''
          let deletIndustrytemp = ''

          if (res.data.body.addBrands.length > 0) {
            addtemp = res.data.body.addBrands
              .map((item) => item.brandName)
              .join('、')
          }
          if (res.data.body.deleteBrands.length > 0) {
            deletetemp = res.data.body.deleteBrands
              .map((item) => item.brandName)
              .join('、')
          }
          if (res.data.body.addIndustries.length > 0) {
            addIndustrytemp = res.data.body.addIndustries
              .map((item) => item.bigIndustryName)
              .join('、')
          }
          if (res.data.body.deleteIndustries.length > 0) {
            deletIndustrytemp = res.data.body.deleteIndustries
              .map((item) => item.bigIndustryName)
              .join('、')
          }
          this.tipIndustryMessage1 = addIndustrytemp
            ? '实际添加行业为:' + addIndustrytemp
            : null
          this.tipIndustryMessage2 = deletIndustrytemp
            ? '实际移除行业为:' + deletIndustrytemp
            : null

          this.tipMessage1 = addtemp ? '实际添加品牌为:' + addtemp : null
          this.tipMessage2 = deletetemp ? '实际移除品牌为:' + deletetemp : null

          if (
            res.data.body.addBrands.length === 0 &&
            res.data.body.deleteBrands.length === 0 &&
            res.data.body.addIndustries.length === 0 &&
            res.data.body.deleteIndustries.length === 0
          ) {
            this.tipMessage3 = '实际未做更改'
            this.canSave = false
            return
          }
          this.canSave = true
          this.saveDialogVisible = true
        }
      })

      // if (this.restIndustryNum === 0 && this.restBrandNum === 0) {
      //   let arr = []
      //   this.industryListtwo.map((item) => {
      //     let obj = {
      //       permitType: 'industry',
      //       permitCode: item.bigIndustryCode,
      //     }
      //     arr.push(obj)
      //   })
      //     .join(',')
      //     .split(',');
      //   let arr1 = []
      //   this.selectedList.map((item) => {
      //     let obj1 = {
      //       permitType: 'brand',
      //       permitCode: item.brandCode,
      //     }
      //     arr1.push(obj1)
      //   })

      //     .join(',')
      //     .split(',');
      //   let arr2 = arr.concat(arr1)
      //   let data = {
      //     mealReqs: arr2
      //   }
      //   ADDPERMITS(data).then(res => {
      //     if (res.data.code == 'error') {
      //       this.$message.error(res.data.msg)
      //     } else {
      //       this.$message({
      //         message: '保存成功',
      //         type: 'success'
      //       });
      //       this.industrymap()
      //       this.queryInfo()
      //       this.permits()
      //       this.updateStr()
      //     }
      //   })
      // } else {
      //   this.$message.error('您还有' + this.restIndustryNum + '个行业和' + this.restBrandNum + '个品牌' + '没有添加')
      // }
    },
    // 保存操作
    handleSave() {
      console.log(this.restIndustryNum, this.restBrandNum)
      let arr = []
      this.addIndustryList
        .map((item) => {
          arr.push(item.bigIndustryCode)
        })
        .join(',')
        .split(',')

      let arr3 = []
      this.deleteIndustryList
        .map((item) => {
          arr3.push(item.bigIndustryCode)
        })
        .join(',')
        .split(',')

      let arr1 = []
      this.addList
        .map((item2) => {
          arr1.push(item2.brandCode)
        })
        .join(',')
        .split(',')

      let arr2 = []
      this.deleteList
        .map((item3) => {
          arr2.push(item3.brandCode)
        })
        .join(',')
        .split(',')
      let data = {
        addBrands: arr1,
        deleteBrands: arr2,
        addIndustries: arr,
        deleteIndustries: arr3
      }
      ADDPERMITS(data).then((res) => {
        if (res.data.code == 'error') {
          this.$message.error(res.data.msg)
        } else {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          this.saveDialogVisible = false
          this.industrymap()
          this.queryInfo()
          // this.permits();
          this.updateStr()
          // 清空待确认队列
          this.addIndustryList = []
          this.deleteIndustryList = []
          this.addList = []
          this.deleteList = []
        }
      })
    },
    /**
     * deleteHandel()
     * 删除购买记录
     */
    deleteHandel(scope) {
      this.$confirm('确定要删除该购买记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteDict(scope)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    deleteDict(scope) {
      DEL({
        id: scope.id
      }).then((res) => {
        if (res.data.code == 'error') {
          this.$message.error(res.data.msg)
        } else {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.decords()
        }
      })
    },
    /**
     * purchase()
     * 立即购买
     */
    purchase() {
      this.$router.push('./package')
      // this.dialogVisibletwo = true
    },
    /**
     * 套餐续费/ s升级
     */
    renew(e) {
      let date1_s = this.endDate.replace(/\-/g, '/')
      let date2_s = this.$moment()
        .format('YYYY-MM-DD HH:mm:ss')
        .replace(/\-/g, '/')
      let date1_unix = Date.parse(date1_s) //將字符串格式日期转化为时间戳，就是1970年到当前日期的毫秒数
      let date2_unix = Date.parse(date2_s) //將字符串格式日期转化为时间戳，就是1970年到当前日期的毫秒数
      if (date1_unix - date2_unix < 0) {
        this.$router.push('./package')
      } else {
        if (this.mealType == 'FREE_DAY') {
          this.$router.push('./package')
        } else {
          if (e == 1) {
            this.$router.push({ path: '/payment', query: { type: 1 } })
          } else {
            this.$router.push({ path: '/payment', query: { type: 2 } })
          }
        }
      }
    },
    dialogVi() {
      this.dialogVisiblesher = false
      this.$router.push('./info')
    },
    /**
     * signout()
     * 退出登录
     */
    signout() {
      EXIT().then((res) => {
        if (res.data.code == 'error') {
          this.$message.error(res.data.msg)
        } else {
          this.$router.push('login')
        }
      })
    },
    /**
     * submitimg()
     * 更换头像
     */
    submitimg(i, index) {
      this.isactive = index
      if (i) {
        this.disabled = false
      }
      this.id = i.id
      this.headImgUrl = i.url
    },
    /**
     * oksubmit()
     * 确定替换
     */
    oksubmit() {
      let data = {
        id: this.form.id,
        headImgUrl: this.headImgUrl
      }
      HEADIMG(data).then((res) => {
        if (res.data.code == 'error') {
          this.$message.error(res.data.msg)
        } else {
          this.$router.push({ path: './demo', query: { r: 6 } })
          // this.queryInfo()
        }
      })
      this.dialogVisible = false
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {
      this.dialogVisible = false
    },
    // 指引文檔
    goguide() {
      let routeUrl = this.$router.resolve({
        path: '/guide'
      })
      window.open(routeUrl.href, '_blank')
    },
    remoteMethod(query) {
      if (query) {
        CHECKBRANDATPERMIT({
          value: query,
          currentPage: 1,
          pageSize: 100
        }).then((res) => {
          this.opshend = []
          let arr = res.data.body
          arr.map((item) => {
            this.opshend.push(Object.assign({}, item, { iscat: false }))
          })
          // this.opshend.filter((item, index) => {
          //   let i = 0
          //   while (i < this.selectedList.length) {
          //     if (item.brandCode == this.selectedList[i].brandCode) {
          //       this.opshend[index].isconts = true; i = this.selectedList.length;
          //     } else { ++i; }
          //   }
          // })
        })
      }
    },
    // 添加品牌
    addbrands(e, index) {
      if (this.restBrandNum != 0) {
        this.opshend[index].havePermit = !this.opshend[index].havePermit
        var obj = {
          brandCode: e.brandCode,
          brandLogo: e.brandLogo,
          brandName: e.brandName
        }
        this.selectedList.push(obj)
        this.handleAddList(obj)
        this.restBrandNum--
        // if (this.restBrandNum < 0) {
        //   this.restBrandNum = 0;
        // }
        this.value = ''
        this.clickedIndustry.forEach((item) => {
          item.value.forEach((item2) => {
            if (item2.brandCode == e.brandCode) {
              item2.havePermit = true
            }
          })
        })
      } else {
        this.$message.error('没有剩余可添加数量!')
      }
    },
    mouseover(e, index) {
      this.opshend[index].iscat = true
    },
    mouseout(e, index) {
      this.opshend[index].iscat = false
    },

    openEmailVer() {
      this.emaildialogVisible = true
    },
    // 发送验证码 (修改密码) forget
    sendForget() {
      if (!this.form.account) {
        this.$message({
          message: '请填写邮箱后获取验证码',
          type: 'warning'
        })
      } else if (
        !/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(
          this.form.account
        )
      ) {
        this.$message({
          message: '请填写正确的邮箱后获取验证码',
          type: 'warning'
        })
      } else {
        let data = {
          account: this.form.account,
          type: 'email'
        }
        CODEFORPASSWORD(data).then((res) => {
          if (res.data.code == 'error') {
            this.$message.error(res.data.msg)
            let timer = 60
            this.isSendForget = true
            this.sendmsgforgetcomlis = timer
          } else {
            this.isSendForget = false
            let timer = 60
            this.sendmsgforgetcomlis = timer + 's'
            this.timeFuns = setInterval(() => {
              --timer
              this.sendmsgforgetcomlis = timer + 's'
              if (timer == 0) {
                this.isSendForget = true
                this.sendmsgforgetcomlis = '重新发送'
                clearInterval(this.timeFuns)
              }
            }, 1000)
          }
        })
      }
    },
    handleVerifyEmail() {
      let data = {
        account: this.form.account,
        code: this.form.code
      }
      EMAILVERIFY(data).then((res) => {
        if (res.data.code == 'error') {
          this.$message.error(res.data.msg)
        } else {
          this.emaildialogVisible = false
          this.$message.success('验证成功')
          this.queryInfo()
        }
      })
    },
    handleClickOutside(event) {
      if (
        this.$refs.targetElement &&
        !this.$refs.targetElement.contains(event.target)
      ) {
        this.value = ''
        this.isDropdownVisible = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.pad15 {
  padding-left: 15px;
}

.padt0 {
  padding-top: 0 !important;
}

.pt10 {
  padding-top: 5px !important;
}

.pd54 {
  padding-top: 34px;
  max-height: 270px;
  overflow: auto;
}

.pd54::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #a6a8bf;
}

.pd54::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #ededed;
}

.pd54::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.w75 {
  width: 75%;
}

.industli {
  width: 100px;
  height: 34px;
  line-height: 34px;
  border: 1px solid #000;
  padding: 0 16px;
  margin-right: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  justify-content: center;

  img {
    width: 17px;
    margin-right: 8px;
  }
}

.industli2 {
  width: 135px;
  height: 34px;
  line-height: 34px;
  border: 1px solid #000;
  padding: 0 10px;
  margin-right: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  img {
    width: 17px;
    margin-right: 8px;
  }

  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.renews_top {
  height: 40px;
  align-items: center;
  // .renews {
  //   margin-left: 20px;
  //   border-bottom: 1px solid #be3c6e;
  //   line-height: 30px;
  // }
}

.renews {
  width: 77px;
  height: 31px;
  line-height: 31px;
  background: #000;
  margin-right: 20px;
}

@media screen and (min-width: 1000px) and (max-width: 2000px) {
  .P_Table {
    width: 333px;
    margin-left: 460px;
    // text-align: center;
    margin-bottom: 17px;
  }
}

@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .P_Table {
    width: 333px;
    margin-left: 555px;
    // text-align: center;
    margin-bottom: 17px;
  }
}

.nologins {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5, #000);
  z-index: 1;

  .nologins_title {
    width: 400px;
    height: 400px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -200px;
    margin-left: -200px;
    background: #fff;
    border-radius: 15px;
    padding: 20px;
  }

  .nologins_title2 {
    width: 400px;
    height: 200px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -200px;
    margin-left: -200px;
    background: #fff;
    border-radius: 15px;
    padding: 20px;
  }

  .nologins_title_icon {
    width: 100%;
    text-align: right;
    font-size: 26px;
    padding-right: 10px;

    i {
      color: #000;
    }
  }

  .nologins_title_img {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    margin-top: 40px;

    img {
      width: 200px;
      height: 200px;
      display: inline-block;
      margin: 0 auto;
    }
  }

  .nologins_title_p {
    width: 100%;
    text-align: center;
    margin-top: 20px;
  }

  .nologins_title_text {
    width: 100%;
    margin-top: 50px;
    font-size: 22px;

    span {
      display: inline-block;
      width: 77px;
      height: 31px;
      line-height: 31px;
      background: #000;
      margin: 0 10px;
    }
  }
}

.buy {
  justify-content: center;

  .buy_en {
    width: 100%;
    justify-content: center;

    div {
      border-bottom: 1px solid #be3c6e;
      line-height: 30px;
    }
  }
}

.emailver {
  display: inline-block;
  width: 90px;
  height: 38px;
  line-height: 38px;
  margin-left: 5px;
  border-radius: 5px;
}

.form_butt {
  display: inline-block;
  width: 90px;
  height: 38px;
  line-height: 38px;
  margin-left: 5px;
  border-radius: 5px;
  float: right;
}

.info {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: #fafafd;

  @media screen and (min-width: 1000px) and (max-width: 2000px) {
    .top_center {
      // width: 1600px;
      margin: 0 auto;
    }

    .list {
      padding: 0 10px;
      width: 100%;
      height: 130px;
      flex-wrap: wrap;
      justify-content: flex-start;
      min-width: calc((100% - 10px) / 5);
      overflow: auto;

      button {
        cursor: pointer;
        width: calc((100% - 10px) / 5);
        min-width: calc((100% - 1px) / 5);
        max-width: calc((100% - 10px) / 5);
        display: flex;
        justify-content: center;
        height: 30px;
        margin-bottom: 15px;

        .ckcr {
          width: 50px;
          height: 33px;
          line-height: 33px;
          padding: 0 13px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .empty {
        visibility: hidden;
        width: 15%;
        height: 0px;
        margin: 0 5px;
      }
    }
  }

  @media screen and (min-width: 2000px) and (max-width: 3000px) {
    .top_center {
      // width: 1920px;
      margin: 0 auto;
    }
  }

  .list {
    padding: 0 10px;
    width: 100%;
    height: 130px;
    flex-wrap: wrap;
    justify-content: flex-start;
    min-width: calc((100% - 10px) / 5);
    overflow: auto;

    button {
      cursor: pointer;
      width: calc((100% - 10px) / 5);
      min-width: calc((100% - 1px) / 5);
      max-width: calc((100% - 10px) / 5);
      display: flex;
      justify-content: center;
      height: 30px;
      margin-bottom: 15px;
      padding-right: 8px;

      .ckcr {
        width: 80px;
        height: 33px;
        line-height: 33px;
        padding: 0 13px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .empty {
      visibility: hidden;
      width: 15%;
      height: 0px;
      margin: 0 5px;
    }
  }

  .list::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background: #a6a8bf;
  }

  .list::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 10px;
    background: #ededed;
  }

  .list::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  .top_center {
    // min-width: 1500px;
    // max-width: 1920px;
    // margin: 0 auto;
    .conten_box {
      width: 100%;
      height: 100%;
      background: rgb(250, 250, 253);
      padding: 10px;

      .con_title {
        width: 100%;
        // height: 92px;
        text-align: left;
        // line-height: 92px;
        font-size: 18px;
        font-weight: 600;
      }

      .already {
        max-height: 220px;
        min-height: 40px;
        overflow: auto;

        div {
          line-height: normal;
        }
      }

      .already::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        background: #a6a8bf;
      }

      .already::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        border-radius: 10px;
        background: #ededed;
      }

      .already::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 4px;
        /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }

      .con_title_top {
        width: 100%;
        padding-bottom: 50px;
        border-bottom: 1px solid #e7e8f2;
        display: flex;
        position: relative;

        .bcedits {
          display: inline-block;
          width: 97px;
          height: 40px;
          align-items: center;
          justify-content: center;
          background: #be3c6e;
          box-shadow: inset 0px 3px 20px 1px rgba(92, 92, 92, 0.16);
          border-radius: 5px 5px 5px 5px;
          opacity: 1;
          border: 3px solid #be3c6e;
          position: absolute;
          bottom: 50px;
          right: 0;
        }

        .preserve {
          width: 188px;
          height: 84px;
          text-align: center;
          line-height: 84px;
          background: #be3c6e;
          border-radius: 5px;
          color: #fff;
          position: absolute;
          right: 0;
          bottom: 50px;
        }

        .select_hp {
          justify-content: space-between;
          width: 100%;

          .select_hp_top {
            width: 100%;
            height: 190px;
            // overflow: auto;

            .pdle {
              padding-top: 6px;

              .pdtop {
                padding-top: 0px !important;
                padding-bottom: 22px;
              }
            }
          }

          .select_hp_top_two {
            width: 100%;
          }

          .select_hp_top::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 10px;
            background: #a6a8bf;
          }

          .select_hp_top::-webkit-scrollbar-track {
            /*滚动条里面轨道*/
            border-radius: 10px;
            background: #ededed;
          }

          .select_hp_top::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 4px;
            /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }

          .left {
            width: 100%;
          }

          .nright {
            width: 40%;
          }

          .rchoose {
            width: 60%;
            padding-top: 6px;
          }

          .let_list {
            width: 100%;
            height: 180px;
            padding: 6px 0;

            .ttlt {
              width: 100%;
              padding-left: 15px;
            }
            .list {
              padding: 0;
            }
          }

          .let_list_two {
            width: 100%;
            padding: 20px;

            .list_two {
              height: 33px;
              align-items: center;
              padding: 0 8px;
              background: #eaebf0;
              margin-right: 10px;
              margin-bottom: 10px;

              .p1 {
                margin-right: 40px;
                font-size: 14px;
              }

              .p2 {
                width: 16px;
                height: 16px;
                justify-content: center;
                align-items: center;
                border: 1px solid #000;
              }
            }
          }

          .rig_list {
            width: 100%;
            max-height: 326px;
            flex-wrap: wrap;
            justify-content: space-between;
            min-width: calc((100% - 10px) / 5);

            button {
              cursor: pointer;
              width: calc((100% - 10px) / 5);
              min-width: calc((100% - 1px) / 5);
              max-width: calc((100% - 10px) / 5);
              display: flex;
              justify-content: center;
              height: 30px;
              margin-bottom: 15px;

              .ckcr {
                height: 33px;
                line-height: 33px;
                padding: 0 13px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .empty {
              visibility: hidden;
              width: 15%;
              height: 0px;
              margin: 0 5px;
            }

            .rig_lists {
              margin: 7px;
              // margin-bottom: 10px;

              div {
                width: 90%;
                padding: 0 10px;
                height: 33px;
                align-items: center;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                p {
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }

              img {
                width: 18px;
                margin-right: 8px;
              }
            }
          }

          .rig_twos {
            padding: 0 10px;
            width: 100%;
            height: 130px;
            flex-wrap: wrap;
            justify-content: space-between;
            min-width: calc((100% - 10px) / 6);
            overflow: auto;

            button {
              cursor: pointer;
              width: calc((100% - 10px) / 6);
              min-width: calc((100% - 1px) / 6);
              max-width: calc((100% - 10px) / 6);
              display: flex;
              // justify-content: center;
              height: 30px;
              margin-bottom: 15px;

              .ckcr {
                height: 33px;
                line-height: 33px;
                padding: 0 13px;
              }
            }

            .empty {
              visibility: hidden;
              width: 15%;
              height: 0px;
              margin: 0 5px;
            }

            .Selected {
              height: 33px;
              padding: 0 10px;
              align-items: center;
              margin-bottom: 10px;
              background: #eaebf0;
              margin-right: 10px;
              position: relative;

              img {
                width: 18px;
                margin-right: 8px;
              }

              .p1 {
                margin-right: 14px;
                font-size: 14px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .p2 {
                width: 16px;
                height: 16px;
                justify-content: center;
                align-items: center;
                border: 1px solid #000;
                position: absolute;
                right: 5px;
              }
            }

            .Selected2 {
              height: 33px;
              padding: 0 10px;
              align-items: center;
              margin-bottom: 10px;
              margin-right: 10px;
              position: relative;
            }
          }

          .rig_two {
            box-sizing: border-box;
            padding: 0 10px;
            width: 100%;
            height: 260px;
            flex-wrap: wrap;
            justify-content: space-between;
            min-width: calc((100% - 10px) / 9);
            overflow: auto;
            margin-top: 45px;

            button {
              cursor: pointer;
              width: calc((100% - 10px) / 9);
              min-width: calc((100% - 1px) / 9);
              max-width: calc((100% - 10px) / 9);
              display: flex;
              // justify-content: center;
              height: 30px;
              margin-bottom: 15px;

              .ckcr {
                height: 33px;
                line-height: 33px;
                padding: 0 13px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .empty {
              visibility: hidden;
              width: 15%;
              height: 0px;
              margin: 0 5px;
            }

            .Selected {
              height: 33px;
              padding: 0 10px;
              align-items: center;
              margin-bottom: 10px;
              background: #eaebf0;
              margin-right: 10px;
              position: relative;

              img {
                width: 18px;
                margin-right: 8px;
              }

              .p1 {
                padding-right: 5px;
                margin-right: 14px;
                font-size: 14px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .p2 {
                width: 16px;
                height: 16px;
                justify-content: center;
                align-items: center;
                border: 1px solid #000;
                position: absolute;
                right: 8px;
              }
            }
          }

          .rig_edit {
            padding: 0 10px;
            width: 100%;
            flex-wrap: wrap;
            justify-content: space-between;
            min-width: calc((100% - 10px) / 9);
            overflow: auto;

            button {
              cursor: pointer;
              width: calc((100% - 10px) / 9);
              min-width: calc((100% - 1px) / 9);
              max-width: calc((100% - 10px) / 9);
              display: flex;
              // justify-content: center;
              height: 30px;
              margin-bottom: 15px;

              .ckcr {
                height: 33px;
                line-height: 33px;
                padding: 0 13px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .empty {
              visibility: hidden;
              width: 15%;
              height: 0px;
              margin: 0 5px;
            }

            .Selected {
              height: 33px;
              padding: 0 10px;
              align-items: center;
              margin-bottom: 10px;
              background: #eaebf0;
              margin-right: 10px;
              position: relative;

              img {
                width: 18px;
                margin-right: 8px;
              }

              .p1 {
                padding-right: 5px;
                margin-right: 14px;
                font-size: 14px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .p2 {
                width: 16px;
                height: 16px;
                justify-content: center;
                align-items: center;
                border: 1px solid #000;
                position: absolute;
                right: 8px;
              }
            }
          }

          button {
            border: none;
            background: none;
          }
        }

        .submithp {
          width: 97px;
          height: 40px;
          line-height: 40px;
          margin: 0 auto;
          margin-bottom: 10px;
        }
      }

      .details {
        width: 300px;
        height: 315px;
        background: #fff;
        // position: absolute;
        box-shadow: 10px 10px 10px 2px rgb(244, 244, 247);

        // right: 40px;
        // top: 20px;
        .con_top {
          width: 100%;
          font-size: 16px;
          margin: 20px 0;
        }

        .con_viv {
          color: #404040;
          font-size: 12px;
          margin-bottom: 20px;
          width: 100%;
        }

        .com_imh {
          width: 124px;
          height: 124px;
          border-radius: 50%;
          margin: 0 auto;
          box-shadow: 10px 10px 10px 2px rgb(244, 244, 247);

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .con_edit {
          width: 138px;
          height: 38px;
          background: #be3c6e;
          color: #fff;
          border-radius: 5px;
          line-height: 38px;
          margin: 0 auto;
          margin-top: 60px;
        }
      }
    }
  }

  .rig_twos::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background: #a6a8bf;
  }

  .rig_twos::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 10px;
    background: #ededed;
  }

  .rig_twos::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  .rig_two::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background: #a6a8bf;
  }

  .rig_two::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 10px;
    background: #ededed;
  }

  .rig_two::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  .hedimg {
    width: 100%;
    text-align: center;

    .hedimg_img {
      display: inline-block;
      width: 110px;
      height: 100%;
      margin: 5px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        display: block;
        box-sizing: border-box;
      }

      // background: pink;
    }
  }

  .addclass {
    border: 1px solid;
    border-radius: 50%;
  }
}

.ckco {
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  background: #eaebf0;
}

.part {
  box-sizing: border-box;
  padding: 0 15px;
  padding-bottom: 10px;

  .el_sele {
    width: 100%;
    position: relative;
    cursor: pointer;

    .el_op {
      width: 100%;
      background: #fff;
      box-shadow: 1px 5px 5px rgba(0, 0, 0, 0.1);
      position: absolute;
      top: 50px;
      left: 0;
      z-index: 1;
      max-height: 300px !important;
      min-height: 40px;
      overflow: auto;

      .el_op_list {
        position: relative;
        height: 40px;
        padding: 0 30px;

        .el_op_list_brandName {
          width: 15%;
        }

        .el_op_list_website {
          width: 50%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          box-sizing: border-box;
          padding-right: 10px;
        }

        .add {
          padding: 0 !important;
          width: 75px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid !important;
          position: absolute;
          right: 30px;
        }

        .add1 {
          padding: 0 !important;
          width: 75px;
          height: 30px;
          line-height: 30px;
          position: absolute;
          right: 30px;
        }
      }

      .el_op_list:hover {
        background: rgba(166, 168, 191, 0.25);
      }

      .ischoose {
        background: rgba(166, 168, 191, 0.25);
      }
    }

    .el_op::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      background: #a6a8bf;
    }

    .el_op::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      border-radius: 10px;
      background: #ededed;
    }

    .el_op::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 4px;
      /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }

    .el_op2 {
      width: 100%;
      height: 40px;
      box-shadow: 1px 5px 5px rgba(0, 0, 0, 0.1);
    }
  }
}

.expire {
  width: calc(100% - 230px);
  height: 50px;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1;
  box-sizing: border-box;

  .expire_top {
    position: relative;

    .expire_icon {
      position: absolute;
      right: 35px;

      i {
        font-size: 20px;
      }
    }
  }
}

// /deep/ .el-dialog__header {
//   padding: 0 !important;
// }

.addfo {
  // width: 520px;
  // height: 360px;
  padding: 10px 0 0 36px;
  font-size: 17px !important;
  font-weight: 600 !important;
}

/deep/ .name_butt {
  width: 100%;
  justify-content: center;
  margin-bottom: 12px;

  div {
    width: 110px;
    height: 40px;
    line-height: 40px;
  }

  .mr8 {
    margin-right: 10px;
  }

  .butt2 {
    border: 1px solid #be3c6e;
  }
}
</style>
<style lang="less">
.savebtn {
  margin-top: 50px;
}

.el-menu-vertical-demo {
  border: none;
}

.down_popover {
  padding: 20px 0;
  border-radius: 5px;
  height: 250px;
  overflow: auto;
}

.info {
  .el-radio-button__inner {
    background: #fff;
    width: 64px;
    height: 65px;
    line-height: 50px;
    border: none;
  }

  .el-radio-button:first-child .el-radio-button__inner {
    border: none;
  }

  .el-radio-button__inner {
    border: none;
  }

  .el-table--border .el-table__cell,
  .el-table__body-wrapper
    .el-table--border.is-scrolling-left
    ~ .el-table__fixed {
    border-right: 1px solid #fff;
  }

  .el-button:hover {
    background: #fff;
  }

  .el-menu-vertical-demo {
    min-height: 100%;
    width: 65px;
  }

  .el-select-dropdown__item {
    color: #000;
  }

  .el-select-dropdown__item.selected {
    color: #be3c6e;
  }

  .el-form-item__label {
    text-align: right;
  }

  .el-collapse-item__header {
    border: none;
    height: 64px;
    // background: #be3c6e;
    border-radius: 0px 5px 5px 0px;
  }

  .el-collapse {
    border: none;
  }

  .el-menu-item i {
    display: none;
  }

  .el-icon-arrow-right:before {
    content: '\';
    color: #000;
    font-size: 16px;
  }

  .el-table__fixed-right {
    z-index: 1 !important;
  }

  .el-table__cell {
    margin: 0 !important;
  }

  .el-table td.el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    border-left: none !important;
    border-right: none !important;
  }

  .el-table tr {
    border-top: 1px solid #000 !important;
  }

  .el-button:focus,
  .el-button:hover {
    color: #707070 !important;
    border-color: #707070 !important;
  }
}
</style>
